import React, { Component } from "react";
import PopupForm from "../components/popup-form";

class Button extends Component {
    constructor(props) {
        super(props);
        this.popupForm = PopupForm.instance();
    }

    get chevronContent() {
        return (
            <div className="button__chevron">
                <svg
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.66663 1.5L10.8133 8.64667C11.0086 8.84133 11.0086 9.158 10.814 9.35267L10.8133 9.35333L3.66663 16.5"
                        stroke="#1D1D1D"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>
        );
    }
    get chevronRepaymentContent() {
        return (
            <div className="button__chevron">
                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 2H7C5.89543 2 5 2.89543 5 4V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V4C19 2.89543 18.1046 2 17 2Z" stroke="#1D1D1D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <rect x="7" y="5" width="10" height="5" rx="1" fill="#1D1D1D"></rect>
                    <rect x="7" y="12" width="2" height="2" rx="1" fill="#1D1D1D"></rect>
                    <rect x="7" y="16" width="6" height="2" rx="1" fill="#1D1D1D"></rect>
                    <rect x="11" y="12" width="2" height="2" rx="1" fill="#1D1D1D"></rect>
                    <rect x="15" y="12" width="2" height="2" rx="1" fill="#1D1D1D"></rect>
                    <rect x="15" y="16" width="2" height="2" rx="1" fill="#1D1D1D"></rect>
                </svg>
            </div>
        );
    }
    get reverseChevronContent() {
        return (
            <div className="button__reverse-chevron">
                <div className="back-btn-fix">
                    <svg
                        width="16"
                        height="18"
                        viewBox="0 0 16 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M3.66663 1.5L10.8133 8.64667C11.0086 8.84133 11.0086 9.158 10.814 9.35267L10.8133 9.35333L3.66663 16.5"
                            stroke="#1D1D1D"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>
        );
    }

    get openLinkContent() {
        return (
            <span className="button__open-link">
                <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4 8V17C4 18.1046 4.89543 19 6 19H15"
                        stroke="#FFE322"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M10 5H18M18 5V13M18 5L10 13"
                        stroke="#FFE322"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        );
    }

    handleClick = (e) => {
        const { popupForm } = this.props;

        if (popupForm) {
            e.preventDefault();
            this.popupForm.open({ type: popupForm });
        }
    };

    render() {
        const {
            href,
            target,
            type,
            title,
            modifiers,
            chevron,
            chevronRepayment,
            reverseChevron,
            wheel,
            loading,
            popupForm,
            extraClass,
            openLink,
            ...rest
        } = this.props;
        const props = {};
        props.className = "button";
        props.onClick = this.handleClick;
        modifiers.forEach((m) => (props.className += ` button--${m}`));

        if (wheel) props.className += ` button--wheel`;
        if (loading) props.className += ` button--loading`;
        if (openLink) props.className += ` button--openLink`;
        if (extraClass) props.className += ` ${extraClass}`;

        let Tag;

        if (href) {
            Tag = "a";
            props.href = href;
            props.target = target || "";
        } else {
            Tag = "button";
            props.type = type || "";
        }

        return (
            <Tag {...props} {...rest}>
                {chevron ? this.chevronContent : ""}
                {chevronRepayment ? this.chevronRepaymentContent : ""}
                {reverseChevron ? this.reverseChevronContent : ""}
                {openLink ? this.openLinkContent : ""}
                {title}
            </Tag>
        );
    }
}

export { Button };
